/**
 * Приводит XML, сгенерированный moddle, к формату XSD Archimate (element/baseElement, bendpoint/waypoint и т.д.).
 * См. ARCHIMATE_XML_ADAPTER.md.
 *
 * @param {string} xml — строка XML от moddle.toXML
 * @returns {string} — XML, готовый к экспорту
 */
export function prepareForExport(xml) {
	const parser = new DOMParser();
	const xmlDoc = parser.parseFromString(xml, 'application/xml');
	const allElements = xmlDoc.getElementsByTagName('*');

	const replaceAttributeMap = new Map([
		['id', 'identifier'],
		['type', 'xsi:type'],
		['xmlns:archimate', 'xmlns'],
	]);

	const removeAttribute = [];

	for (let i = allElements.length - 1; i >= 0; i--) {
		const el = allElements[i];

		replaceAttributeMap.forEach((value, key) => {
			if (el.hasAttribute(key)) {
				el.setAttribute(value, el.getAttribute(key));
				el.removeAttribute(key);
			}
		});

		removeAttribute.forEach(key => {
			if (el.hasAttribute(key)) {
				el.removeAttribute(key);
			}
		});

		const xsiType = el.getAttribute('xsi:type') || el.getAttribute('type');
		if (xsiType === 'TechnologyNode') {
			el.setAttribute('xsi:type', 'Node');
			if (el.hasAttribute('type')) el.removeAttribute('type');
		}

		if (el.localName === 'baseElement') {
			const newEl = xmlDoc.createElementNS(null, 'element');
			for (const attr of el.attributes) {
				newEl.setAttribute(attr.name, attr.value);
			}
			while (el.firstChild) {
				newEl.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(newEl, el);
		} else if (el.localName === 'waypoints') {
			while (el.firstChild) {
				el.parentNode.appendChild(el.firstChild);
			}
			el.parentNode.removeChild(el);
		} else if (el.localName === 'waypoint') {
			const newEl = xmlDoc.createElementNS(null, 'bendpoint');
			for (const attr of el.attributes) {
				newEl.setAttribute(attr.name, attr.value);
			}
			while (el.firstChild) {
				newEl.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(newEl, el);
		} else {
			const newEl = xmlDoc.createElementNS(null, el.localName);
			for (const attr of el.attributes) {
				newEl.setAttribute(attr.name, attr.value);
			}
			while (el.firstChild) {
				newEl.appendChild(el.firstChild);
			}
			el.parentNode.replaceChild(newEl, el);
		}
	}

	shiftCoordinatesForArchi(xmlDoc);

	return new XMLSerializer().serializeToString(xmlDoc);
}

/**
 * Сдвигает все координаты так, чтобы минимум был ≥ 0.
 * Archi не принимает отрицательные значения x/y в XML.
 *
 * @param {Document} xmlDoc — документ после преобразований
 */
export function shiftCoordinatesForArchi(xmlDoc) {
	let minX = Infinity;
	let minY = Infinity;
	const coordElements = xmlDoc.querySelectorAll('[x][y], [x], [y]');

	for (let i = 0; i < coordElements.length; i++) {
		const el = coordElements[i];
		const xVal = parseFloat(el.getAttribute('x'));
		const yVal = parseFloat(el.getAttribute('y'));
		if (!Number.isNaN(xVal)) minX = Math.min(minX, xVal);
		if (!Number.isNaN(yVal)) minY = Math.min(minY, yVal);
	}

	const offsetX = minX < 0 ? -minX : 0;
	const offsetY = minY < 0 ? -minY : 0;
	if (offsetX === 0 && offsetY === 0) return;

	for (let i = 0; i < coordElements.length; i++) {
		const el = coordElements[i];
		if (el.hasAttribute('x')) {
			const x = parseFloat(el.getAttribute('x'));
			if (!Number.isNaN(x)) el.setAttribute('x', String(Math.round(x + offsetX)));
		}
		if (el.hasAttribute('y')) {
			const y = parseFloat(el.getAttribute('y'));
			if (!Number.isNaN(y)) el.setAttribute('y', String(Math.round(y + offsetY)));
		}
	}
}
